<template>
  <yxt-drawer
    :title="$t('pc_setup')"
    :visible="visible"
    @close="handleCancel"
    size="480px"
    direction="rtl"
  >
    <yxt-form
      ref="formRef"
      class="form-box"
      :model="formData"
      is-need-require
      is-need-tooltip
      label-width="110px"
    >
      <yxt-form-item
        :label="$t('pc_label_no_audit')"
        prop="roles"
      >
        <yxt-select
          v-model="formData.roles"
          multiple
          :placeholder="$t('pc_select_placeholder')"
          icon-name="more"
          hidden-option
          collapse-tags
          value-key="id"
          prop-label="name"
          @visible-change="dialogVisible=true"
        >
          <template
            slot='tag'
            slot-scope='{ data }'
          >
            <yxtbiz-user-name :name="data.currentLabel" />
          </template>
        </yxt-select>
        <div class="tip color-gray-7">
          {{$t('pc_tip_skip_audit')}}
        </div>
      </yxt-form-item>

    </yxt-form>
    <div slot="footer">
      <yxt-button
        plain
        @click="handleCancel"
      >{{$t('pc_cancel_mini')}}</yxt-button>
      <yxt-button
        type='primary'
        @click="handleOk"
      >{{$t('pc_ok_mini')}}</yxt-button>
    </div>

    <yxt-drawer
      ref="selectDrawer"
      :header-border='false'
      :destroy-on-close="true"
      size="960px"
      :visible.sync="dialogVisible"
    >
      <yxtbiz-range-selector
        ref="selector"
        model="array"
        :selected="formData.roles"
        @change='users=$event'
        :tabs="['persons', 'advance', 'userGroup']"
        :function-code='functionCode'
        :data-permission-code='dataPermissionCode'
        >
      </yxtbiz-range-selector>
      <div slot='footer'>
        <yxt-button
          @click="dialogVisible=false"
          plain
        >{{$t('pc_cancel')}}</yxt-button>
        <yxt-button
          type="primary"
          @click="selectUserOk"
        >{{$t('pc_ok')}}</yxt-button>
      </div>
    </yxt-drawer>
  </yxt-drawer>
</template>
<script>

export default {
  inject: [ 'functionCode', 'dataPermissionCode' ],
  props: {
    appters: {
      type: Array,
      default: () => []
    },
    userGroup: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: true,
      limit: 10,
      users: [],
      dialogVisible: false,
      formData: {
        roles: []
      },
      rules: {
        // roles: [
        //   { required: true, message: this.$t('pc_select_role_audit'), trigger: 'blur' }
        // ]
      }
    };
  },
  watch: {
    appters: {
      immediate: true,
      handler(v) {
        if (v) {
          // hack ??格式未确定
          const users = v.filter(it => it.userId).map(it => {
            return {
              id: it.userId,
              fullname: it.fullName,
              name: it.fullName,
              nodeType: 'persons'
            };
          });
          const userGroup = this.userGroup.filter(it => it.id).map(it => {
            return {
              id: it.id,
              name: it.name || it.userGroupName,
              nodeType: 'userGroup'
            };
          });
          this.users = this.formData.roles = users.concat(userGroup);
        }
      }
    }

  },
  methods: {
    handleVisible(v) {
      this.$emit('update:visible', v);
    },
    handleCancel() {
      this.visible = false;
      this.handleVisible(false);
    },
    handleOk() {
      this.$refs.formRef.validate((isOk) => {
        if (isOk) {
          const { roles } = this.formData;
          const appters = roles.filter(item => item.nodeType === 'persons').map(it => ({
            userId: it.id,
            fullName: it.fullname
          }));
          const userGroup = roles.filter(item => item.nodeType === 'userGroup').map(it => {
            return {
              id: it.id,
              name: it.name
            };
          });
          this.$emit('click:ok', { appters, userGroup });
        }
      });
    },
    selectUserOk() {
      const users = this.users.filter(item => item.nodeType === 'persons');
      const userGroups = this.users.filter(item => item.nodeType === 'userGroup');
      if (users.length > 200) {
        this.$message.warning(this.$t('pc_slelct_max', [200]));
        return;
      }
      if (userGroups.length > 3) {
        this.$message.warning('最多选择3个用户组');
        return;
      }
      this.formData.roles = this.users.map(item => ({ ...item, name: (item.name || item.fullname) }));
      this.dialogVisible = false;
    }
  }
};
</script>
<style scoped>
.form-box /deep/ .yxt-select {
  width: 328px;
}
</style>
